import './view.css';

const NAME = 'd-view';

export class View extends HTMLElement {

  connectedCallback () {
    this.classList.add(NAME);
  }

  /**
   * Notifies the orchestrator that something important changed in this view, and we should update the state
   *
   * @protected
   * @param eventType - the type of event we dispath
   * @param data - the detail of the event
   */
  notify (eventType, data) {
    this._isDispatching = true;
    this.dispatchEvent(new CustomEvent(eventType, { detail: data, bubbles: true }));
    this._isDispatching = false;
  }

  /**
   * @protected
   * @return {boolean} Whether the view is dispatching some event
   */
  get isDispatching () {
    return this._isDispatching;
  }

}
